import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SignInComponent } from '@app/pages/sign-in/sign-in.component';
import { AxiomPageComponent } from '@app/shared/components/axiom-page/axiom-page.component';
import { SharedModule } from '@app/shared/shared.module';

import { AlreadyAssignedComponent } from './dialog/already-assigned/already-assigned.component';
import { AoiPackageFailedComponent } from './dialog/aoi-package-failed/aoi-package-failed.component';
import { AssignChartFailedComponent } from './dialog/assign-chart-failed/assign-chart-failed.component';
import { CancelDownloadComponent } from './dialog/cancel-download/cancel-download.component';
import { ChartPreparationFailedComponent } from './dialog/chart-preparation-failed/chart-preparation-failed.component';
import { CheckSdCardComponent } from './dialog/check-sd-card/check-sd-card.component';
import { DownloadWithUrlComponent } from './dialog/download-with-url/download-with-url.component';
import {
  EditChartCustomNameDialogComponent,
} from './dialog/edit-chart-custom-name-dialog/edit-chart-custom-name-dialog.component';
import { EmailNotificationComponent } from './dialog/email-notification/email-notification.component';
import { HowToPopupComponent } from './dialog/how-to-popup/how-to-popup.component';
import { ImprovementSubmittedComponent } from './dialog/improvement-submitted/improvement-submitted.component';
import { TransferExceptionDialogComponent } from './dialog/transfer-exception-dialog/transfer-exception-dialog.component';
import { TransferOwnershipDialogComponent } from './dialog/transfer-ownership-dialog/transfer-ownership-dialog.component';
import {
  UsingNonRaymarineCardComponent,
} from './dialog/using-non-raymarine-card/using-non-raymarine-card/using-non-raymarine-card.component';
import { HealthComponent } from './health/health.component';
import { OverviewComponent } from './overview/overview.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { SupportComponent } from './support/support.component';
import { VersionComponent } from './version/version.component';
import { DownloadOptionsComponent } from './dialog/download-options/download-options.component';
import { UpgradeChartSuccessComponent } from './dialog/upgrade-chart-success/upgrade-chart-success.component';
import { AddedToCartComponent } from './dialog/added-to-cart/added-to-cart.component';
import { LargeFileNotificationComponent } from './dialog/large-file-notification/large-file-notification.component';
import { HowToGuideComponent } from './how-to-guide/how-to-guide.component';
import { EditAccountDetailsComponent } from './dialog/edit-account-details/edit-account-details.component';
import { EditAddressComponent } from './dialog/edit-address/edit-address.component';
import { AutoRenewComponent } from './dialog/auto-renew/auto-renew.component';
import { ConsentAgreementComponent } from './dialog/consent-agreement/consent-agreement.component';
import { DeleteCreditCardComponent } from './dialog/delete-credit-card/delete-credit-card.component';
import { SetDefaultCreditCardComponent } from './dialog/set-default-credit-card/set-default-credit-card.component';
import { ChartEntitlementDetailsComponent } from './dialog/chart-entitlement-details/chart-entitlement-details.component';
import { SmallChartDownloadedAcknowledgedComponent } from '@app/pages/dialog/small-chart-downloaded-acknowledged/small-chart-downloaded-acknowledged.component';

@NgModule({
  declarations: [
    PagesComponent,
    SignInComponent,
    PageNotFoundComponent,
    AxiomPageComponent,
    HowToPopupComponent,
    DownloadWithUrlComponent,
    CheckSdCardComponent,
    CancelDownloadComponent,
    EmailNotificationComponent,
    AlreadyAssignedComponent,
    ChartPreparationFailedComponent,
    AssignChartFailedComponent,
    AoiPackageFailedComponent,
    ImprovementSubmittedComponent,
    SupportComponent,
    HealthComponent,
    OverviewComponent,
    UsingNonRaymarineCardComponent,
    TransferOwnershipDialogComponent,
    TransferExceptionDialogComponent,
    EditChartCustomNameDialogComponent,
    VersionComponent,
    DownloadOptionsComponent,
    UpgradeChartSuccessComponent,
    LargeFileNotificationComponent,
    HowToGuideComponent,
    AddedToCartComponent,
    LargeFileNotificationComponent,
    EditAccountDetailsComponent,
    EditAddressComponent,
    AutoRenewComponent,
    ConsentAgreementComponent,
    DeleteCreditCardComponent,
    SetDefaultCreditCardComponent,
    ChartEntitlementDetailsComponent,
    SmallChartDownloadedAcknowledgedComponent
  ],
  entryComponents: [
    HowToPopupComponent,
    DownloadWithUrlComponent,
    CheckSdCardComponent,
    CancelDownloadComponent,
    EmailNotificationComponent,
    AlreadyAssignedComponent,
    ChartPreparationFailedComponent,
    AssignChartFailedComponent,
    AoiPackageFailedComponent,
    ImprovementSubmittedComponent,
    UsingNonRaymarineCardComponent,
    TransferOwnershipDialogComponent,
    TransferExceptionDialogComponent,
    EditChartCustomNameDialogComponent,
    DownloadOptionsComponent,
    UpgradeChartSuccessComponent,
    LargeFileNotificationComponent,
    EditAccountDetailsComponent,
    EditAddressComponent,
    ChartEntitlementDetailsComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule
  ]
})
export class PagesModule { }
